declare var moment
declare var angular

angular.module('wbServices').service('calendar', function() {
  this.create = function(startDate, endDate, blockWeekends) {
    return new Calendar(startDate, endDate, blockWeekends)
  }
})

export class Calendar {
  _startDate = moment();
  _endDate = moment();
  _currentDate = moment();
  blockWeekends = false;
  _dates = [];
  _datesKey;
  format = 'YYYY-MM-DD'

  constructor(startDate, endDate, blockWeekends) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.blockWeekends = blockWeekends;
    this.currentDate = endDate;
  }

  get startDate() {
    if (!this._startDate.isValid()) return moment(0);
    return this._startDate;
  }
  set startDate(value) {
    this._startDate = moment(value, this.format, true);
  }

  get endDate() {
    if (!this._endDate.isValid()) return moment({ hour: 0 });
    return this._endDate
  }
  set endDate(value) {
    this._endDate = moment(value, this.format, true);
  }

  get currentDate() {
    if (!this._currentDate.isValid()) return moment({ hour: 0 });
    if (this._currentDate.isBefore(this.startDate)) return this.startDate.clone();
    if (this._currentDate.isAfter(this.endDate)) return this.endDate.clone();
    return this._currentDate;
  }
  set currentDate(value) {
    this._currentDate = moment(value, this.format, true);
  }

  get currentYear() { return this.currentDate.year() }
  set currentYear(value) {
    this.currentDate = this.currentDate.year(value);
  }

  get currentMonth() { return this.currentDate.month() }
  set currentMonth(value) {
    this.currentDate = this.currentDate.month(value);
  }

  get isFirstMonth() {
    return this.currentDate.format('YM') === this.startDate.format('YM');
  }

  get isLastMonth() {
    return  this.currentDate.format('YM') === this.endDate.format('YM');
  }

  get years() {
    let years = []
    for (let i = this.startDate.year(); i <= this.endDate.year(); i++) { years.push(i) }
    return years
  }

  get months() {
    if (this.currentYear == null) return
    let year = this.currentYear
    let startMonth = 0
    let endMonth = 11
    if (this.startDate.year() === year) {  startMonth = this.startDate.month() }
    if (this.endDate.year() === year) { endMonth = this.endDate.month() }
    let months = []
    for (let i = startMonth; i <= endMonth; i++) {
      months.push({
        index: i,
        month: moment.months(i)
      })
    }
    return months
  }

  get dates() {
    // This basic cache value avoids resetting the digest loop
    const cacheKey = `${this.currentDate.unix()}${this.startDate.unix()}${this.endDate.unix()}`;
    if (this._datesKey == cacheKey) return this._dates;
    this._datesKey = cacheKey;

    let dates = []
    let start = moment().year(this.currentYear).month(this.currentMonth).startOf('month')
    let end = moment().year(this.currentYear).month(this.currentMonth).endOf('month')
    let range = moment.range(start, end)
    let weekIndex = 0
    Array.from(range.by('d')).forEach((d: any) => {
      if (dates[weekIndex] == null) { dates[weekIndex] = [] }
      let week = dates[weekIndex]

      week.push({
        value: d.toDate(),
        date: d.date(),
        year: d.year(),
        month: d.month() + 1,
        week: d.week(),
        day: d.day(),
        invalid: !this.isValidDate(d),
      })
      if (d.weekday() === 6) weekIndex++
    })
    if (dates.length > 0) {
      // Pad the first week array for empty calendar slots
      let firstWeekDays = dates[0].length
      for (let i = 0; i < 7 - firstWeekDays; i++) {
        dates[0].unshift({ extra: true })
      }
    }
    this._dates = dates;
    return this._dates;
  }

  prevMonth() {
    this.currentDate = this.currentDate.subtract(1, 'month');
  }

  nextMonth() {
    this.currentDate = this.currentDate.add(1, 'month');
  }

  private isValidDate(date) {
    var valid: boolean = date.isSameOrBefore(this.endDate) && date.isSameOrAfter(this.startDate)
    if (this.blockWeekends) {
      valid = valid && ([0, 6].indexOf(moment(date).weekday()) === -1)
    }
    return valid
  }
}
